export class DispoList {
    selectable: boolean = true;
    state: string | null = null;
    state_abbreviation: string | null = null;
    bound_book_id: string | null = null;
    firearm_id: number | null = null;
    firearm: string | null = null;
    serial_number: string | null = null;
    received_from: string | null = null;
    date_acquired: string | null = null;
    select_item: boolean | undefined = null;
}
